import React from 'react';
import { useAuth } from '@/contexts/EnterpriseAuthContext';
import { InactivityWarningModal } from './InactivityWarningModal';

export function InactivityMonitor() {
  const { isWarning, remainingSeconds, stayActive } = useAuth();

  return (
    <InactivityWarningModal
      isOpen={isWarning}
      remainingSeconds={remainingSeconds}
      onStayActive={stayActive}
    />
  );
}